import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';

import { DialogData, DialogResult } from 'src/app/global/models/dialog/dialog-data';
import { PdfDialogData, PdfDialogDataResult } from 'src/app/global/models/dialog/pdf-dialog-data';
import { ResumeHiringDialogData, ResumeHiringDialogResult } from 'src/app/global/models/dialog/resume-hiring-data';

import { DialogThreeInfoComponent } from 'src/app/main/dialogs/dialog-three-info/dialog-three-info.component';
import { OneActionComponent } from 'src/app/main/dialogs/one-action/one-action.component';
import { PdfViewerComponent } from 'src/app/main/dialogs/pdf-viewer/pdf-viewer.component';
import { SegundoPlanoComponent } from 'src/app/main/dialogs/segundo-plano/segundo-plano.component';
import { TwoActionsComponent } from 'src/app/main/dialogs/two-actions/two-actions.component';
import { modalMessages } from 'src/app/messages/step-1-modals';

import { Injectable } from '@angular/core';
import { DialogDataThree, DialogDataThreeResult } from 'src/app/global/models/dialog/dialog-data-three';
import { CiValidationComponent } from 'src/app/main/dialogs/ci-validation/ci-validation.component';
import { CiViewerComponent } from 'src/app/main/dialogs/ci-viewer/ci-viewer.component';
import { DialogErrorComponent } from 'src/app/main/dialogs/dialog-error/dialog-error.component';
import { ResumeHiringComponent } from 'src/app/main/dialogs/resume-hiring/resume-hiring.component';
import { ValoresMCCComponent } from 'src/app/main/dialogs/valores-mcc/valores-mcc.component';
import { modalMessagesStep2 } from 'src/app/messages/step-2-modals';
import { modalMessagesStep3 } from 'src/app/messages/step-3-modals';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { DialogRoundedComponent } from 'src/app/main/dialogs/dialog-rounded/dialog-rounded.component';


@Injectable()
export class DialogServiceProvider extends DialogService {

  constructor(private dialog: MatDialog) {
    super();
  }

  openOneActionDialog(config: MatDialogConfig<DialogData>): MatDialogRef<OneActionComponent, DialogResult> {
    return this.dialog.open(OneActionComponent, config);
  }

  openDialogError(config: MatDialogConfig<DialogData>): MatDialogRef<DialogErrorComponent, DialogResult> {
    return this.dialog.open(DialogErrorComponent, config);
  }


  openProcesoSegundoPlanoDialog(config: MatDialogConfig<DialogData>): MatDialogRef<SegundoPlanoComponent, DialogResult> {
    return this.dialog.open(SegundoPlanoComponent, config);
  }

  openTwoActionsDialog(config: MatDialogConfig<DialogData>): MatDialogRef<TwoActionsComponent, DialogResult> {
    return this.dialog.open(TwoActionsComponent, config);
  }

  openIntentoDialog(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.INTENTO_1_TITLE,
        description: modalMessages.INTENTO_1_DESCRIPTION,
        actionButton: modalMessages.INTENTO_1_BUTTON
      },
      disableClose: true
    });
  }

  openSolicitudVacia(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.SOLICITUD_VACIA_TITLE,
        description: modalMessages.SOLICITUD_VACIA_DESCRIPTION,
        actionButton: modalMessages.SOLICITUD_VACIA_BUTTON
      },
      disableClose: true
    });
  }

  openCambioProductoRechazado(producto: string): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.CAMBIO_PRODUCTO_RECHAZADO_TITLE,
        description: 'Actualmente tienes una solicitud iniciada con el producto ' + producto + '. <br />Por favor, continua con tu proceso de solicitud.',
        actionButton: modalMessages.CAMBIO_PRODUCTO_RECHAZADO_BUTTON
      },
      disableClose: true
    });
  }

  openContratacionNoIniciada(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.CONTRATACION_NO_INICIADA_TITLE,
        description: modalMessages.CONTRATACION_NO_INICIADA_DESCRIPTION,
        actionButton: modalMessages.CONTRATACION_NO_INICIADA_BUTTON
      },
      disableClose: true
    });
  }

  openPdfViewer(url: string): MatDialogRef<PdfViewerComponent, PdfDialogDataResult> {
    const pdfDialogData: PdfDialogData = {
      title: modalMessages.pdfViewer.title,
      download: modalMessages.pdfViewer.download,
      button: modalMessages.pdfViewer.button,
      url
    };
    return this.dialog.open(PdfViewerComponent, {
      data: pdfDialogData,
      disableClose: true,
      autoFocus: false,
      width: '50%'
    });
  }

  openErrorDialog(title: string, message: string) {
    return this.openOneActionDialog({
      data: {
        title,
        description: message,
        actionButton: modalMessages.REINTENTAR_BUTTON
      },
      disableClose: true
    });
  }

  openCuentaabono(title: string, message: string) {
    return this.openOneActionDialog({
      data: {
        title,
        description: message,
        actionButton: modalMessages.REINTENTAR_BUTTON
      },
      disableClose: true
    });
  }

  refreshTokenDialog() {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.REFRESH_TOKEN.TITLE,
        description: modalMessages.REFRESH_TOKEN.BODY,
        actionButton: modalMessages.REFRESH_TOKEN.BTN
      },
      disableClose: true
    });


  }

  openTbkClientDialog(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.CLIENTE_TBK_TITLE,
        description: modalMessages.CLIENTE_TBK_DESCRIPTION,
        actionButton: modalMessages.CLIENTE_TBK_BUTTON
      },
      disableClose: true
    });
  }

  openRequestInProgressDialog(ss: string): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.SS_EN_PROCESO_TITLE,
        description: modalMessages.SS_EN_PROCESO_DESCRIPTION /*+ '<br><br><strong>N° seguimiento:</strong> ' + ss*/,
        actionButton: modalMessages.SS_EN_PROCESO_BUTTON
      },
      disableClose: true
    });
  }

  openInvalidSerieOfRutFirstAttemptDialog(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.INTENTO_1_TITLE,
        description: modalMessages.INTENTO_1_DESCRIPTION,
        actionButton: modalMessages.INTENTO_1_BUTTON
      },
      disableClose: true
    });
  }

  openCedulaNoVigenteDialog(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: 'Error en datos de cédula',
        description: 'Número de serie o cédula no vigente',
        actionButton: modalMessages.REINTENTAR_BUTTON
      },
      disableClose: true
    });
  }


  openInvalidSerieOfRutSecondAttemptDialog(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.INTENTO_1_TITLE,
        description: modalMessages.INTENTO_2_DESCRIPTION,
        actionButton: modalMessages.INTENTO_1_BUTTON
      },
      disableClose: true
    });
  }

  openAccountBloquedDialog(enableButton?: boolean): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.BLOQUEO_3_INTENTOS_TITLE,
        description: modalMessages.BLOQUEO_3_INTENTOS_DESCRIPTION,
        actionButton: modalMessages.BLOQUEO_3_INTENTOS_BUTTON,
        icon: modalMessages.BLOQUEO_3_INTENTOS_IMAGE
      },
      disableClose: true
    });
  }

  openResumeHiringDialog(): MatDialogRef<ResumeHiringComponent, ResumeHiringDialogResult> {
    const hiringMessages = modalMessages.resumeHiring;
    const hiringDialogData: ResumeHiringDialogData = {
      title: hiringMessages.title,
      description: hiringMessages.description,
      question: hiringMessages.question,
      actions: {
        primary: hiringMessages.actions.primary,
        secondary: hiringMessages.actions.secondary
      }

    };
    return this.dialog.open(ResumeHiringComponent, {
      data: hiringDialogData,
      disableClose: true
    });
  }

  openWithoutHiringDialog(): MatDialogRef<OneActionComponent, DialogResult> {
    const accessWithoutHiringMessages = modalMessages.accessWithoutHiring;
    return this.openOneActionDialog({
      data: {
        title: accessWithoutHiringMessages.title,
        description: accessWithoutHiringMessages.description,
        actionButton: accessWithoutHiringMessages.action
      },
      disableClose: true
    });
  }

  openDeleteProductDialog(product: Product): MatDialogRef<TwoActionsComponent, DialogResult> {
    const deleteProductMessages = modalMessages.deleteProduct;
    return this.openTwoActionsDialog({
      data: {
        title: deleteProductMessages.title,
        description: deleteProductMessages.description,
        description2: deleteProductMessages.description2,
        cancelButton: deleteProductMessages.actions.secondary,
        actionButton: deleteProductMessages.actions.primary,
        deleteAction: true,
        productTitle: product.title
      },
      disableClose: true
    });
  }

  openChangeProductDialog(product: Product): MatDialogRef<TwoActionsComponent, DialogResult> {
    const changeProductMessages = modalMessages.changeProduct;
    return this.openTwoActionsDialog({
      data: {
        title: changeProductMessages.title,
        description: changeProductMessages.description,
        description2: changeProductMessages.description2,
        cancelButton: changeProductMessages.actions.secondary,
        actionButton: changeProductMessages.actions.primary,
        deleteAction: true,
        productTitle: product.title
      },
      disableClose: true
    });
  }

  openRubroProhibido11(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessagesStep2.RUBRO_PROHIBIDO_1_1_TITLE,
        description: modalMessagesStep2.RUBRO_PROHIBIDO_1_1_DESCRIPTION,
        actionButton: modalMessagesStep2.RUBRO_PROHIBIDO_1_1_BUTTON
      },
      disableClose: true
    });
  }

  openRutPerteneceAEmpresaDialog(): MatDialogRef<TwoActionsComponent, DialogResult> {
    const messages = modalMessages.cuentaBancaria.rutIngresadoPerteneceAEmpresa;
    return this.openTwoActionsDialog({
      data: {
        title: messages.title,
        description: messages.description,
        cancelButton: messages.actions.secondary,
        actionButton: messages.actions.primary
      },
      disableClose: true
    });
  }

  openRutPerteneceAPropiaDialog(): MatDialogRef<TwoActionsComponent, DialogResult> {
    const messages = modalMessages.cuentaBancaria.rutIngresadoPerteneceAPropia;
    return this.openTwoActionsDialog({
      data: {
        title: messages.title,
        description: messages.description,
        cancelButton: messages.actions.secondary,
        actionButton: messages.actions.primary
      },
      disableClose: true
    });
  }

  openRubroProhibidoNN(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessagesStep2.RUBRO_PROHIBIDO_N_N_TITLE,
        description: modalMessagesStep2.RUBRO_PROHIBIDO_N_N_DESCRIPTION,
        actionButton: modalMessagesStep2.RUBRO_PROHIBIDO_N_N_BUTTON,
        icon: null
      },
      disableClose: true
    });
  }

  openConfirmarFechaDefecto(fecha: string): MatDialogRef<TwoActionsComponent, DialogResult> {
    return this.openTwoActionsDialog({
      data: {
        title: modalMessagesStep3.DATE_CONFIRM_TITLE,
        description: modalMessagesStep3.DATE_CONFIRM_DESCRIPTION,
        description2: fecha,
        cancelButton: modalMessagesStep3.DATE_CONFIRM_BUTTON_CANCEL,
        actionButton: modalMessagesStep3.DATE_CONFIRM_BUTTON_OK
      },
      disableClose: true
    });
  }

  openProductoNoDisponible(producto: string): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessagesStep2.PRODUCTO_PROHIBIDO_TITLE,
        description: 'Lo sentimos, el producto <strong>' + producto + '</strong> no está disponible para la categoría o rubro de tu comercio. Modifica el rubro para validar si puedes adquirir el producto.',
        actionButton: modalMessagesStep2.PRODUCTO_PROHIBIDO_BUTTON
      },
      disableClose: true
    });
  }

  openMaximoProductos(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessagesStep2.PRODUCTO_MAXIMO_TITLE,
        description: modalMessagesStep2.PRODUCTO_MAXIMO_DESCRIPTION,
        actionButton: modalMessagesStep2.PRODUCTO_MAXIMO_BUTTON
      },
      disableClose: true
    });
  }

  openActividadSinCategoria(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessagesStep2.ACTIVIDAD_NO_CATEGORIA_TITLE,
        description: modalMessagesStep2.ACTIVIDAD_NO_CATEGORIA_DESCRIPTION,
        actionButton: modalMessagesStep2.ACTIVIDAD_NO_CATEGORIA_BUTTON
      },
      disableClose: true
    });
  }

  openRetomaPedido(producto: string): MatDialogRef<TwoActionsComponent, DialogResult> {
    return this.openTwoActionsDialog({
      data: {
        title: modalMessages.RETOMA_TITLE,
        description: 'Habías comenzado un proceso de contratación de: ' + producto + '. Para terminar con el proceso que iniciaste selecciona "Retomar contratación".' +
          ' Si deseas continuar con el producto que seleccionaste: ' + producto + 'puedes seguir con la nueva solicitud selecionado "Iniciar nueva solicitud".',
        // description: 'Se guardaron tus datos ingresados del paso 2 y tu solicitud del producto ' + producto + ' ¿Deseas retomar la solicitud?',
        actionButton: modalMessages.RETOMA_BUTTON_RETOMAR,
        cancelButton: modalMessages.RETOMA_BUTTON_PRODUCTOS
      },
      disableClose: true
    });
  }

  openProcesoSegundoPlano(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessagesStep2.PROCESO_SEGUNDO_PLANO_TITLE,
        description: modalMessagesStep2.PROCESO_SEGUNDO_PLANO_DESCRIPTION,
        actionButton: modalMessagesStep2.PROCESO_SEGUNDO_PLANO_BUTTON
      },
      disableClose: true
    });
  }

  openEnSegundoProcesoDialog(): MatDialogRef<SegundoPlanoComponent, DialogResult> {
    return this.openProcesoSegundoPlanoDialog({
      data: {
        title: modalMessagesStep2.PROCESO_SEGUNDO_PLANO_TITLE,
        description: modalMessagesStep2.PROCESO_SEGUNDO_PLANO_DESCRIPTION
      },
      disableClose: true
    });
  }

  openDialogThreeInfoComponent(dialogDataThree: DialogDataThree): MatDialogRef<DialogThreeInfoComponent, DialogDataThreeResult> {
    return this.dialog.open(DialogThreeInfoComponent, {
      data: dialogDataThree,
      disableClose: true,
      autoFocus: false,
      width: '50%'
    });
  }

  closeProcesoSegundoPlanoDialog(): void {
    return this.dialog.closeAll();
  }

  openUnaActividadSinCategoria(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessagesStep2.ACTIVIDAD_SIN_RUBRO_TITLE,
        description: modalMessagesStep2.ACTIVIDAD_SIN_RUBRO_DESCRIPTION,
        actionButton: modalMessagesStep2.ACTIVIDAD_SIN_RUBRO_BUTTON
      },
      disableClose: true
    });
  }

  openFechaVencida(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessages.fechaAgendamientoVencida.title,
        description: modalMessages.fechaAgendamientoVencida.description,
        actionButton: modalMessages.fechaAgendamientoVencida.action
      },
      disableClose: true
    });
  }

  openCiViewerDialog(): MatDialogRef<CiViewerComponent, DialogResult> {
    return this.dialog.open(CiViewerComponent, {
      data: {},
      disableClose: true
    });
  }

  openCiValidationDialog(rut: string, opts:{preventDefaultSubmit?:boolean}={}): MatDialogRef<CiValidationComponent, DialogResult> {    
    const data = {...{rut: rut},...opts}
    return this.dialog.open(CiValidationComponent, {
      data: data,
      disableClose: true
    });
  }


  

  openMaximoSocios(): MatDialogRef<OneActionComponent, DialogResult> {
    return this.openOneActionDialog({
      data: {
        title: modalMessagesStep2.TRES_SOCIOS_FIRMA_CONJUNTA,
        description: modalMessagesStep2.TRES_SOCIOS_FIRMA_DESCRIPTION,
        actionButton: modalMessagesStep2.TRES_SOCIOS_FIRMA_BUTTON
      },
      disableClose: true
    });
  }

  openValoresMCCDialog(): MatDialogRef<ValoresMCCComponent, DialogResult> {
    return this.dialog.open(ValoresMCCComponent, {
      data: {},
      disableClose: true
    });
  }

  openPendienteContactoEjecutivo(): MatDialogRef<DialogRoundedComponent, DialogResult> {
        const config = {
          data:  {
          title: '¡Muy bien!\nestás a un paso de finalizar\ntu contratación 🙌', 
          description: 'Dentro de las próximas horas un ejecutivo Transbank se pondrá en contacto contigo para finalizar tu contratación.',
          actionButton: 'Entendido',
          cancelButton : 'Volver a tienda',
          icon: '',
          errorCode:''
        },
        panelClass: 'default-container'
        ,width: '400px' 
      }

    return this.dialog.open(DialogRoundedComponent, config);
  }

  openPendienteContactoEjecutivoBO(): MatDialogRef<DialogRoundedComponent, DialogResult> {
        const config = {
          data:  {
          title: 'Problemas de conexión con el Registro Civil 😕', 
          description: 'Cuando la conexión se restablezca podrás completar esta contratación.',
          actionButton: 'Entendido',
          icon: '',
          errorCode:''
        },
        panelClass: 'default-container'
        ,width: '400px' 
      }

    return this.dialog.open(DialogRoundedComponent, config);
  }
}
